export const PUMA_APP_ID = "d0eba8b2-a327-4f05-97d7-dd6d9fedce8c";
export const PUMA_MODULE_NAME = "DOLPHIN_STAGE";

export const PUMA_METRICS = {
    STAGE_CART_EVENT_PUBLISH_LATENCY: "stageCartEventPublishLatency"
}